define('lq/events/actions/deleteCommand',[
    'lq/events/actions/eventAction', 
    'lq/events/abortError'
], function (EventAction, AbortError) {
	    'use strict';

	    function DeleteCommand(eventData, eventArg) {
	        EventAction.call(this, eventData, eventArg);
	        return this;
	    }

        EventAction.extend(DeleteCommand, EventAction);

        DeleteCommand.typeName = 'DeleteCommand';

	    DeleteCommand.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

	    DeleteCommand.prototype.createEventActionRequest = function () {
            return {
                eventActionType: "Delete",
                ObjectName: this.eventData.command
            };
        };

        DeleteCommand.prototype.execute = function (continuation, eventActionResponse) {
            if (eventActionResponse.isDirty) {
                if (this.eventIsEnabled('onExecutionTrailDirty')) {
                    this.triggerEvent('onExecutionTrailDirty');
                } else {
                    alert('Could not delete the data, because the data is dirty.');
                }
            } else {
                continuation();
            }

        };

        return DeleteCommand;
    }
);
